import { createContext } from "react";
import { AppData } from "./AppData";

export const AppDataContext = createContext<AppData>({});
